'use client';

import { useState } from 'react';
import styles from './blogComponent.module.scss';
import BlogTabs from './components/BlogTabs';
import BlogMaine from './components/BlogMaine';
import BlogPress from './components/BlogPress';

type BlogComponentProps = {
  currentPage?: number;
};

const BlogComponent = ({ currentPage = 1 }: BlogComponentProps) => {
  const [activeTab, setActiveTab] = useState('all');

  return (
    <section className="container">
      <div className={styles.blogComponent}>
        <BlogTabs activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab === 'all' && <BlogMaine currentPage={currentPage} />}
        {activeTab === 'inThePress' && <BlogPress />}
      </div>
    </section>
  );
};

export default BlogComponent;
